import {
  GET_TOTAL_FEEDBACKS,
  GET_TOTAL_CUSTOMER,
  GET_TOTAL_LOYALITY,
  GET_TOTAL_CAMPAIGN,
  GET_TOTAL_REFFERALS,
  GET_TOTAL_NEGATVIE_FEEDBACK,
  GET_UPCOMING_EVENTS,
  GET_WEIGHTED_GRAPH,
  GET_NON_WEIGHTED_GRAPH,
  GET_FEEDBACK_FORM_TYPE,
  GET_SATISFACTION_SCORE,
  GET_RETENTION_SCORE,
  GET_CLIENT_SUBSCRIPTION_STATUS,
  GET_TOTAL_RESPONSES_WIDGET,
  GET_CSAT_WIDGET,
  GET_NPS_WIDGET,
  GET_AT_RISK_WIDGET,
  GET_SENTIMENT_MIX_WIDGET,
  GET_TICKET_SUMMARY_WIDGET,
  GET_RECENT_NEGATIVE_COMMENTS_WIDGET,
  GET_LOCATION_COMPARISON_WIDGET,
  GET_NEGATIVE_THEMES_WIDGET,
  GET_COMPLAINT_CATEGORIES_WIDGET,
  GET_NPS_TREND_WIDGET,
  GET_SATISFACTION_TREND_WIDGET,
} from '../constants/dashboard'

const initialState = {
  totalFeedbacks: null,
  totalCustomers: null,
  totalLoyality: null,
  totalCampaign: null,
  totalRefferal: null,
  totalNegatvieFeedback: null,
  totalUpcomingEvents: null,
  weightedGraph: null,
  nonWeightGraph: null,
  feedbackFormType: null,
  satisfactionScoreChart: null,
  retentionScoreChart: null,
   subscription: null,
  totalResponsesWidget: null,
  csatWidget: null,
  npsWidget: null,
  atRiskWidget: null,
  sentimentMixWidget: null,
  ticketSummaryWidget: null,
  recentNegativeCommentsWidget: null,
  locationComparisonWidget: null,
  negativeThemesWidget: null,
  complaintCategoriesWidget: null,
  npsTrendWidget: null,
  satisfactionTrendWidget: null,
}

export default function dashboard(state = initialState, action) {
  switch(action.type){
    case GET_TOTAL_FEEDBACKS:
      return { ...state, totalFeedbacks: action.data }

    case GET_TOTAL_CUSTOMER:
      return { ...state, totalCustomers: action.data }
    
    case GET_TOTAL_LOYALITY:
      return { ...state, totalLoyality: action.data }

    case GET_TOTAL_CAMPAIGN:
      return { ...state, totalCampaign: action.data }

    case GET_TOTAL_REFFERALS:
      return { ...state, totalRefferal: action.data }

    case GET_TOTAL_NEGATVIE_FEEDBACK:
      return { ...state, totalNegatvieFeedback: action.data }
    
    case GET_UPCOMING_EVENTS:
      return { ...state, totalUpcomingEvents: action.data }

    case GET_WEIGHTED_GRAPH:
      return { ...state, weightedGraph: action.data }

    case GET_NON_WEIGHTED_GRAPH:
      return { ...state, nonWeightGraph: action.data }

    case GET_FEEDBACK_FORM_TYPE:
      return { ...state, feedbackFormType: action.data }

    case GET_SATISFACTION_SCORE:
      return { ...state, satisfactionScoreChart: action.data }
      
    case GET_RETENTION_SCORE:
      return { ...state, retentionScoreChart: action.data }

    case GET_CLIENT_SUBSCRIPTION_STATUS:
      return { ...state,subscription: action.data };

    case GET_TOTAL_RESPONSES_WIDGET:
      return { ...state, totalResponsesWidget: action.data }

    case GET_CSAT_WIDGET:
      return { ...state, csatWidget: action.data }

    case GET_NPS_WIDGET:
      return { ...state, npsWidget: action.data }

    case GET_AT_RISK_WIDGET:
      return { ...state, atRiskWidget: action.data }

    case GET_SENTIMENT_MIX_WIDGET:
      return { ...state, sentimentMixWidget: action.data }

    case GET_TICKET_SUMMARY_WIDGET:
      return { ...state, ticketSummaryWidget: action.data }

    case GET_RECENT_NEGATIVE_COMMENTS_WIDGET:
      return { ...state, recentNegativeCommentsWidget: action.data }

    case GET_LOCATION_COMPARISON_WIDGET:
      return { ...state, locationComparisonWidget: action.data }

    case GET_NEGATIVE_THEMES_WIDGET:
      return { ...state, negativeThemesWidget: action.data }

    case GET_COMPLAINT_CATEGORIES_WIDGET:
      return { ...state, complaintCategoriesWidget: action.data }

    case GET_NPS_TREND_WIDGET:
      return { ...state, npsTrendWidget: action.data }

    case GET_SATISFACTION_TREND_WIDGET:
      return { ...state, satisfactionTrendWidget: action.data }

    default:
      return state
      
  }
}